import React, { useState, useEffect } from 'react';
import { Button, Icon } from 'antd';

interface Props {
  changeStatus: () => void;
}

const sucess = (props: Props) => {
  const [count, setCount] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount(count - 1)
    }, 1000)

    return () => {
      if (count <= 1) {
        props.changeStatus();
      }
      clearInterval(timer)
    }
  })

  return (
    <div className="succcess">
      <h1>注册成功</h1>
      <div><Icon type="check-circle" style={{ color: ' #34495e', fontSize: 80 }} /></div>
      <p style={{ textAlign: 'center' }}>{count}s后跳转登陆</p>
      <Button className="login-form-button" onClick={() => props.changeStatus()}>登陆</Button>
    </div>
  )
}
export default sucess